import { DEFAULTSTAFF_ROUTE_NAME } from '@/libs/route-name';

export const defaultstaffRoute = () => {
    return {
        name: DEFAULTSTAFF_ROUTE_NAME.DEFAULTSTAFF,
        path: 'defaultstaff',
        component: () => import('@/pages/defaultstaff/index.vue'),
    };
};
